<div class="wrapper">
    <!-- Aside End -->
    <main class="middle-content">
        <!-- Page Title Start -->
        <div class="page_title_block">
            <h1 class="page_title">Exchange Management</h1>
        </div>
        <!-- Page Title End -->
        <div class="content-section">
            <div class="outer-box">
                <!-- Gloabl Table Box Start -->
                <div class="global-table no-radius p0">
                    <div class="tab-content1">
                        <div class="tab-pane1">
                            <div class="sec_head_new">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="head_flt_select search-div">
                                            <input type="text" placeholder="Search by email" class="form-control "
                                                [(ngModel)]="searchText">
                                            <div class="input-group-append" style="margin-left: 10px;">
                                                <button class="btn btn_search_group" type="button"><img
                                                        src="assets/img/icon-search.png" alt="Search"
                                                        (click)="applyFilter('text')"></button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2" style="padding-left: 0px;">
                                        <div class="head_flt_select">
                                            <div class="head_flt_select input-label input-label1">
                                                <span class="d-flex align-items-center">Type</span>
                                                <select class="form-control" [(ngModel)]="type"
                                                    (change)="onChange($event.target.value)">
                                                    <option value="">Type</option>
                                                    <option value="BUY">Buy</option>
                                                    <option value="SELL">Sell</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2" style="padding-left: 0px;">
                                        <div class="head_flt_select">
                                            <div class="head_flt_select input-label input-label1">
                                                <span class="d-flex align-items-center">Start Date</span>
                                                <input type="date" max="{{minAge | date:'yyyy-MM-dd'}}" name="formdate"
                                                    [(ngModel)]="calender.formdate" (change)="formdate()"
                                                    class="form-control datepicker" placeholder="Search by date">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-2" style="padding-left: 0px;">
                                        <div class="head_flt_select">
                                            <div class="head_flt_select input-label input-label1">
                                                <span class="d-flex align-items-center">End Date</span>
                                                <input type="date" name="todate" min="{{fromDate | date:'yyyy-MM-dd'}}"
                                                    (change)="todate()" [disabled]="!calender.formdate"
                                                    [(ngModel)]="calender.todate" class="form-control datepicker"
                                                    placeholder="Search by date">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="transaction">
                                <div class="row"></div>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-bordered" aria-describedby="exchange management table">
                                    <thead>
                                        <tr class="no_wrap_th">
                                            <th scope="col">ID</th>
                                            <th scope="col">User Name</th>
                                            <th scope="col">User Email</th>
                                            <th scope="col">Min Transaction</th>
                                            <th scope="col">Max Transaction</th>
                                            <th scope="col">Created Date</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Type</th>
                                            <th scope="col">Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let transactionitem of exchangeArry | paginate: { itemsPerPage: 10, currentPage: p, totalItems: total}; let i = index"
                                            [attr.data-index]="i">
                                            <td><a class="id-table">{{transactionitem.fkUserId || "no records"}}</a>
                                            </td>
                                            <td><a class="id-table">{{transactionitem.userName || "no records"}}</a>
                                            </td>
                                            <td>{{transactionitem.email || "no records"}}</td>
                                            <td>{{transactionitem.minValue || "no records"}}</td>
                                            <td>{{transactionitem.maxValue || "no records"}}</td>
                                            <td>{{transactionitem.creationTime | date : 'short' || "no records"}}</td>
                                            <td><a>{{transactionitem.orderStatus || "no records"}}</a></td>
                                            <td>{{transactionitem.orderType || "no records"}} </td>
                                            <td>{{transactionitem.price || "no records"}}</td>
                                        </tr>

                                    </tbody>
                                </table>
                            </div>

                            <div class="custom-pagination mt20 text-center">
                                <pagination-controls (pageChange)="pagination($event)"></pagination-controls>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <!-- Table Responsive End -->

    </main>
    <!-- Middle Content End -->
    <footer>
        <div class="container-fluid">
            <p class="copyright">Copyright © 2019 <strong class="theme-text-color">CryptoBiz Exchange</strong> All
                Rights Reserved.</p>
        </div>
    </footer>
    <!-- Footer Finish -->
</div>
<!-- Wrapper End -->

<!--Modal Start-->
<div class="modal fade global-modal reset-modal" id="delet_farms_modal">
    <div class="modal-dialog max-WT-500">
        <div class="modal-content">
            <!-- Modal body -->
            <div class="modal-body  text-center">
                <div class="row align-items-center modal_flax_height">
                    <div class="col">
                        <div class="box-title mb40 d-inline-block">
                            <h2>Are you sure?</h2>
                            <p>You won’t be able to revert this!</p>
                        </div>
                        <div class="max-WT-300 d-inline-block border-top">
                            <button type="button" class="btn btn-gray btn-large radius0 btn-block">YES</button>
                            <button type="button" class="btn btn-red btn-large radius0 btn-block"
                                data-dismiss="modal">CANCEL</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- signout_modal Start -->

<!-- Signout Modal -->
<!-- invite_modal Start -->
<div class="modal fade global-modal reset-modal" id="invite">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div>
                    <div class="modal-header ">
                        <h4 class="modal-title text-center">Invite</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row align-items-center modal_flax_height">
                            <div class="col">
                                <div class="form-group">
                                    <label class="control-labe">Email*</label>
                                    <input class="form-control" placeholder="" required="" type="email">
                                </div>
                                <div class="form-group">
                                    <label class="control-labe">Subject</label>
                                    <input class="form-control" placeholder="" required="" type="text">
                                </div>
                                <div class="form-group">
                                    <label class="control-labe">Message</label>
                                    <textarea name="" id="" cols="20" rows="5" class="form-control">
                                </textarea>
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <button type="submit"
                                            class="btn btn-gray btn-large radius0 btn-block">SUBMIT</button>
                                    </div>
                                    <div class="col-6">
                                        <button type="button" class="btn btn-red btn-large radius0 btn-block"
                                            data-dismiss="modal">CANCEL</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- invite_modal End -->
<!-- invite_modal Start -->
<div class="modal fade global-modal reset-modal" id="accept">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div>
                    <div class="modal-header ">
                        <h4 class="modal-title text-center">Accept</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row align-items-center modal_flax_height">
                            <div class="col">
                                <div class="form-group">
                                    <div class="d-flex align-items-center text-center justify-content-center">
                                        <label class="switch">
                                            <input type="checkbox">
                                            <span class="slider round"></span>
                                        </label>
                                        <strong> R/W Accesbility</strong>
                                    </div>
                                </div>
                                <hr>
                                <div class="form-group">
                                    <div class="d-flex align-items-center">
                                        <div class="w-100">
                                            <h6>User Type</h6>

                                            <div class="radio_btn_cst d-flex">
                                                <label class="radio_style">End User
                                                    <input type="radio" checked="checked" name="radio" />
                                                    <span class="checkmark"></span>
                                                </label>
                                                <label class="radio_style">Service User
                                                    <input type="radio" name="radio" />
                                                    <span class="checkmark"></span>
                                                </label>
                                                <label class="radio_style">Admin User
                                                    <input type="radio" name="radio" />
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="w-100">
                                        <h6>Role</h6>
                                        <select name="" class="form-control form-control2 select_opt">
                                            <option value="">Select</option>
                                            <option value="" selected>Abuja region</option>
                                            <option value="">Nigeria region</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="d-flex align-items-center flex-wrap text-center justify-content-center">
                                        <div class="w-50 d-inline-flex align-items-center">
                                            <label class="switch">
                                                <input type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                            <span> Admin Rights</span>
                                        </div>
                                        <div class="w-50 d-inline-flex align-items-center">
                                            <label class="switch">
                                                <input type="checkbox">
                                                <span class="slider round"></span>
                                            </label>
                                            <span> Approved</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt20 text-center">
                                    <button class="btn btn-small btn-info">Set</button>
                                    <button class="btn btn-small btn-danger" data-dismiss="modal">Cancel</button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
<!-- invite_modal End -->


<!-- block_modal Start -->
<div class="modal fade global-modal reset-modal" id="block">
    <div class="modal-dialog max-WT-500">
        <form class="change_password">
            <div class="modal-content">
                <div>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>

                    <div class="modal-body">
                        <div class="text-center modal_flax_height d-flex align-items-center justify-content-center">
                            <div class="w-100">
                                <p>Are you sure want to block this user?</p>
                                <div>
                                    <button type="submit" class="btn btn-success">Yes</button>
                                    <button type="button" class="btn btn-danger" data-dismiss="modal">No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>


<!-- Modal start -->
<div class="modal fade" id="Take" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Take decision tradee</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="modal-btn">
                    <button class="btn btn-seller">Release Escroe For Seller</button>
                    <button class="btn btn-buyer">Release Escroe For Buyer</button>
                </div>
            </div>
        </div>
    </div>
</div>



<!-- Modal end -->